import { USERMODALS, GROUPMODALS, MEMBERMODAL } from '../../common/actionTypes';
const INITIAL_STATE = {
  userModal: false,
  requestModal: false,
  groupModal: false,
  memberModal: false
};

const modalReducer = (state = INITIAL_STATE, action) => {
  if (action.type === undefined) {
    return state;
  }
  switch (action.type) {
    case USERMODALS: {
      return { ...state, userModal: action.value };
    }
    case GROUPMODALS: {
      return { ...state, groupModal: action.value };
    }
    case MEMBERMODAL: {
      return { ...state, memberModal: action.value };
    }
    default:
      return state;
  }
};

export default modalReducer;
